import React from 'react';
import Grid2 from '@mui/material/Grid2';
import { useTranslation } from 'react-i18next';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import Picklist from '../../../components/Picklist';
import CountyAreasFields from '../../../components/CountyAreasFields';
import FormSection from '../../../components/FormSection';
import { CaregiverFormData } from '../types';
import { FieldErrors } from '../validation';

interface Props {
  formData: CaregiverFormData;
  fieldErrors: FieldErrors;
  handleChange: (e: { target: { name: string; value: any } }) => void;
  handleCheckboxChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleMultiSelectChange: (e: { target: { name: string; value: string[] } }) => void;
}

const AvailabilityStep: React.FC<Props> = ({
  formData,
  fieldErrors,
  handleChange,
  handleCheckboxChange,
  handleMultiSelectChange,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <FormSection title={t('form.availability', 'Availability')} icon={<EventAvailableIcon />}>
        <Grid2 container spacing={2}>
          <Grid2 container size={12} spacing={2}>
            <Grid2 size={{ xs: 12, sm: 6 }}>
              <Picklist
                fieldName="ableToDrive"
                value={formData.ableToDrive}
                onChange={handleChange}
                label={t('form.ableToDrive', 'Do you drive?')}
                objectName="caregiver"
                required
                error={!!fieldErrors.ableToDrive}
                helperText={fieldErrors.ableToDrive}
              />
            </Grid2>
            {formData.ableToDrive === 'Yes' && (
              <Grid2 size={{ xs: 12, sm: 6 }}>
                <Picklist
                  fieldName="hasACar"
                  value={formData.hasACar}
                  onChange={handleChange}
                  label={t('form.hasACar', 'Do you have a car?')}
                  objectName="caregiver"
                  required
                  error={!!fieldErrors.hasACar}
                  helperText={fieldErrors.hasACar}
                />
              </Grid2>
            )}
          </Grid2>

          <CountyAreasFields
            values={formData}
            fieldErrors={fieldErrors}
            handleCheckboxChange={handleCheckboxChange}
            handleMultiSelectChange={handleMultiSelectChange}
          />
        </Grid2>
      </FormSection>

      <FormSection title={t('form.preferences', 'Preferences')} icon={<PersonSearchIcon />}>
        <Grid2 container spacing={2}>
          <Grid2 size={{ xs: 12, sm: 6 }}>
            <Picklist
              fieldName="worksWithPets"
              value={formData.worksWithPets}
              onChange={handleChange}
              label={t('form.worksWithPets', 'Can you work with pets?')}
              objectName="caregiver"
              required
              error={!!fieldErrors.worksWithPets}
              helperText={fieldErrors.worksWithPets}
            />
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 6 }}>
            <Picklist
              fieldName="worksWithSmokers"
              value={formData.worksWithSmokers}
              onChange={handleChange}
              label={t('form.worksWithSmokers', 'Can you work with smokers?')}
              objectName="caregiver"
              required
              error={!!fieldErrors.worksWithSmokers}
              helperText={fieldErrors.worksWithSmokers}
            />
          </Grid2>
        </Grid2>
      </FormSection>
    </>
  );
};

export default AvailabilityStep;
